<template>
  <v-app>
    <Loading />
    <router-view></router-view>
  </v-app>
</template>

<script>
import Loading from '@/components/layouts/dashboard/Loading.vue'
export default {
  name: 'App',
  components: {
    Loading,
  },
}
</script>
